const API_BASE = process.env.REACT_APP_API_BASE || "https://api.alumni.uem.mz";
export const BUILDER_BASE = (API_BASE || "") + "/api/v1/builder";
